<template>
  <div class="content">
    <div class="Tabs">

      <b-tabs card>

        <b-tab :title="lang.tab_QuickView" :title-link-class="textColors" :title-item-class="textColors"  active>

          <div v-if="selectedRows.length != 1">
            <p>{{lang.infotext_1}}</p>
          </div>
          
            <QuickViewTableComponent v-if="selectedRows.length == 1" :source="'false'" :lang="lang.QuickView"></QuickViewTableComponent>
            <!-- <LibraryFilesComponent v-if="selectedRows.length == 1" :lang="lang.LibraryFiles"></LibraryFilesComponent> -->
            
            <IpcSimpleViewerComponent v-if="selectedRows.length == 1 && appConf.status.isBasicBundle == false" name="ProjectTable" :lang="lang.IPCSimpleViewer" ></IpcSimpleViewerComponent>
        </b-tab>

        <!-- <b-tab v-if="!isPlugin" :title="lang.tab_Tasks" :title-link-class="textColors" :title-item-class="textColors"  >
          <div v-if="selectedRows.length != 1">
              <p>{{lang.infotext_2}}</p>
          </div>
            
          <ProjectTasksComponent v-if="selectedRows.length == 1&&!isPlugin" :lang="lang.Tasks"  parent="table"></ProjectTasksComponent>
        </b-tab>
        <b-tab :title="lang.tab_Report"  :title-link-class="textColors" :title-item-class="textColors"  >

          <ProjectChangeReportComponent :lang="lang.ProjectReport" parent="details"></ProjectChangeReportComponent>
        </b-tab> -->
        <!-- <b-tab :title="lang.tab_WhereUse" :title-link-class="textColors" :title-item-class="textColors"  >
          <div v-if="selectedRows.length != 1">
              <p>{{lang.infotext_2}}</p>
          </div>
          <WhereUseTableComponent  :parent="'parts'"  v-if="selectedRows.length == 1" :lang="lang.WhereUse"></WhereUseTableComponent>
          
        </b-tab> -->
               

      </b-tabs>

  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'
import ProjectTasksComponent from '@/components/shared/ProjectTasksComponent'
import WhereUseTableComponent from '@/components/shared/WhereUseTableComponent'
import ProjectChangeReportComponent from '@/components/shared/ProjectChangeReportComponent'
import IpcSimpleViewerComponent from '@/components/shared/IpcSimpleViewerComponent'


export default {
  name: "Content",
  components: {
    QuickViewTableComponent,
    ProjectTasksComponent,
    WhereUseTableComponent,
    ProjectChangeReportComponent,
    IpcSimpleViewerComponent
    
  },
  props:{
    lang: Object,

  },
  data () {
    return {
      

    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      isPlugin: 'isPlugin',
      appConf: 'appConf',
    }),
    selectedType(){
      
      return false;
    },
        
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {

  },
  updated() {

  },

  watch: {
    

  },
  methods: {

  }
}
</script>

<style lang="scss">

  .Tabs{

    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectTable/Right/Content/Content.vue